import { Experiments } from '@src/constants/abTest';
import { useHasUtmLabel } from '@src/reducers/route';

import { useTestVariant } from './useTestVariants';

export function useAbSeaExperiment() {
  const hasUtmLabel = useHasUtmLabel();
  const { isBVariant } = useTestVariant(Experiments.EXCLUDE_FULLDEAL_OFFERS);
  return { isSeaExcludeFeatureExperiment: isBVariant && !hasUtmLabel };
}
